<template lang="pug">
AppDropdown(
  :class="dropdownClass"
  :direction="direction"
  trigger-classes="btn btn-naked"
)
  template(#trigger)
    .d-flex.align-items-center.dropdown-toggle.btn(
      v-tooltip="tooltipOptions"
      data-toggle="dropdown"
      :data-original-title="title"
    )
      span
        | {{ active.abbr }}
      i.hi.hi-caret.hi-10.ml-5
  li.app-column-toggle(
    v-for="(option, index) in options"
    :key="index"
  )
    a(@click="onClick(option)")
      .row
        .col-xs-12.text-lighter
          | {{ option.description }}
      .row
        .col-xs-12
          p.m-0
            | {{ option.abbr }}:
            | {{ option.display_name }}
</template>
<script>
export default {
  name: 'AppTimeZoneDropdown',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    // ActiveTimeZone object
    active: {
      type: Object,
      default: () => ({}),
    },
    direction: {
      type: String,
      default: 'left',
    },
    options: {
      type: Array,
      default: () => [],
    },
    tooltipOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['input'],
  computed: {
    dropdownClass() {
      return {
        disabled: this.disabled,
        'vue-app-time-zone-dropdown': true,
      };
    },
    title() {
      return `${this.active.display_name} (${this.active.offset})`;
    },
  },
  methods: {
    onClick(option) {
      if (!this.disabled) {
        this.$emit('input', option.for, option.description);
      }
    },
  },
};
</script>
